import React, { useEffect } from "react";
import { useHistory, useParams, withRouter } from "react-router-dom";

import AuthenticationLoading from "../../components/Authentication";
import { useGlobal } from "../../contexts/globalContext";
import SsoRepository from "../../repositories/ssoRepository";

const inFlightRedirectHashes = new Set();
const consumedRedirectHashes = new Set();

function SsoRedirect() {
	const history = useHistory();
	const { hash } = useParams();
	const { login, logout, showAlert, setLoadingPointsBalance } = useGlobal();

	useEffect(() => {
		let isMounted = true;

		const authenticateWithRedirectHash = async () => {
			if (!hash) {
				showAlert("error", "Link de acesso inválido.");
				history.replace("/login");
				return;
			}

			if (inFlightRedirectHashes.has(hash) || consumedRedirectHashes.has(hash)) {
				return;
			}

			inFlightRedirectHashes.add(hash);
			setLoadingPointsBalance(true);
			logout();

			try {
				const ssoRepository = new SsoRepository();
				const { data } = await ssoRepository.consumeRedirectHash(hash);
				const expectedCampaignId = process.env.REACT_APP_CAMPAIGN_ID?.toString();
				const expectedCampaignCode = process.env.REACT_APP_CAMPAIGN_CODE?.toString();
				const returnedCampaignId = data?.campaign?.id?.toString();
				const returnedCampaignCode = data?.campaign?.code?.toString();

				if (!data?.legacyJwt) {
					throw new Error("missing-legacy-jwt");
				}

				if ((expectedCampaignId && returnedCampaignId !== expectedCampaignId) || (expectedCampaignCode && returnedCampaignCode !== expectedCampaignCode)) {
					throw new Error("campaign-mismatch");
				}

				sessionStorage.setItem(
					"auth",
					JSON.stringify({
						access_token: data.legacyJwt,
						accessToken: data.legacyJwt,
					})
				);

				if (returnedCampaignCode) {
					sessionStorage.setItem("campaign", returnedCampaignCode);
				}

				const result = await login();
				if (!isMounted) return;

				if (!result?.success) {
					throw new Error(result?.error || "login-failed");
				}

				consumedRedirectHashes.add(hash);
				history.replace("/");
			} catch (error) {
				logout();
				showAlert("error", "Não foi possível autenticar seu acesso. Solicite um novo link.");
				history.replace("/login");
			} finally {
				inFlightRedirectHashes.delete(hash);
				if (isMounted) {
					setLoadingPointsBalance(false);
				}
			}
		};

		authenticateWithRedirectHash();

		return () => {
			isMounted = false;
		};
	}, [hash, history, login, logout, setLoadingPointsBalance, showAlert]);

	return <AuthenticationLoading />;
}

export default withRouter(SsoRedirect);
